import { Pipe, PipeTransform } from '@angular/core';
import { toFriendlyString } from '../../model/utility';


@Pipe({
  name: 'friendlyString',
  standalone: false
})
export class FriendlyStringPipe implements PipeTransform {
  transform(value: string): string {
    return toFriendlyString(value);
  }
}
